var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 389,
    viewBox: "0 0 235 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.6405 129.068C26.293 82.9705 63.28 43.1424 95.6851 0C99.577 48.6388 115.034 96.3662 112.274 145.475C143.879 171.99 193.287 181.27 234.028 186.573C194.391 205.134 159.143 234.466 118.926 251.673C124.943 296.805 111.998 343.261 115.393 389C100.239 363.728 80.8627 339.422 54.3093 324.728C43.9584 319.011 38.4104 305.671 28.4184 299.953C-13.4543 305.505 -54.0572 338.759 -98 343.565C-79.1201 299.484 -42.0778 260.705 -28.4699 216.099C-50.3033 191.683 -65.5121 162.212 -86.1034 137.078C-91.5411 129.289 -86.1862 129.068 -78.7336 129.041C-55.2441 127.825 -22.8666 139.15 -1.6405 129.068Z",
    fill: "#A8D29B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLeft);
export default __webpack_public_path__ + "static/media/star-left.253954418b93e4e5514fc101e499d507.svg";
export { ForwardRef as ReactComponent };